export default __webpack_public_path__ + "static/media/jackpot.0f471332.png";